import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Box, CircularProgress, Typography } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import getBanners from "../api/banner/getBanners";

const ImageCarousel = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const data = await getBanners();
        console.log(data);
        const combinedData = data.Image.map((image, index) => ({
          src: image,
          link: data.Link[index] || "",
        }));
        setImages(combinedData);
      } catch (err) {
        setError("Failed to fetch banners");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  const hasMultipleImages = images.length > 1;

  const settings = {
    dots: hasMultipleImages,
    infinite: hasMultipleImages,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: hasMultipleImages,
    arrows: hasMultipleImages,
    draggable: hasMultipleImages,
    swipe: hasMultipleImages,
    autoplaySpeed: 6000,
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
        <div
          style={{
            width: "9px",
            height: "9px",
            borderRadius: "60%",
            backgroundColor: "white", // Change this to the color you want
            opacity: "0.4",
            transition: "opacity 0.3s ease",
          }}
          className="slick-dot"
        ></div>
      ),
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box height="30vh" width="100vw">
      <Slider {...settings}>
        {images.map((image, index) => (
          <Box
            key={index}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <a href={image.link} target="_blank" rel="noopener noreferrer">
              <img
                src={image.src}
                alt={`Image ${index}`}
                style={{
                  width: "100%",
                  height: "30vh",
                  maxHeight: "30vh",
                  borderRadius: "10px",
                  objectFit: "contain",
                }}
              />
            </a>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default ImageCarousel;
